module.exports = __webpack_public_path__ + "img/HealthWarning.424ad917.svg";